enum MobileLayout {
    default,
    secondUp,
    hideFirstColumn,
    hideSecondColumn,
}

export default MobileLayout;
